function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetoothSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1042.717,
    y1: 1343.0902,
    x2: -3131.2168,
    y2: -911.1637,
    gradientTransform: "matrix(-0.9748 -0.1323 0.1345 -0.9909 -654.8552 1069.4224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M653.197,1187.9c369.968-626.69,1147.141-811.938,1719.094-684.721 c156.167,34.735,470.377,104.624,686.163,376.884c414.402,522.857,210.995,1470.568-321.787,1972.459 c-68.611,64.633-541.341,495.898-1174.207,403.354c-463.35-67.756-752.855-378.407-787.95-416.977 c-44.334-48.723-141.145-163.346-219.127-334.924C372.153,2100.826,422.004,1579.519,653.197,1187.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M466.026,479.714c-3.217-13.694,16.046-22.796,27.842-13.231 c119.782,97.13,407.581,387.994,335.856,896.297c-89.99,637.743,63.859,870.451,255.362,1012.397 c0,0-262.998-66.752-428.464-302.883C250.365,1492.538,523.224,723.196,466.026,479.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M557.181,678.906c14.985,70.997,28.34,142.211,38.661,213.745 c10.754,71.474,18.994,143.198,24.633,215.04c5.319,71.855,9.077,143.784,9.291,215.745 c0.588,71.957-2.404,143.854-5.699,216.031c-2.828,72.152-6.151,144.823-0.869,218.01 c5.194,73.037,20.568,146.713,51.076,215.779c7.626,17.213,15.646,34.373,24.756,50.953 c8.758,16.734,18.377,33.137,28.332,49.385c20.102,32.417,42.73,63.739,67.946,93.467 c50.615,59.355,111.659,112.008,178.908,156.57c7.078,4.69,17.218,3.537,22.651-2.575c5.333-6.001,4.142-14.553-2.604-19.301 l-0.048-0.034c-16.001-11.238-31.834-22.621-47.024-34.574c-7.708-5.873-15.097-12.028-22.617-18.061 c-7.246-6.271-14.778-12.302-21.792-18.76c-28.555-25.416-55.01-52.532-79.01-81.203 c-48.276-57.076-86.923-120.677-116.202-186.612c-14.213-33.12-25.575-67.087-33.87-101.692 c-8.266-34.613-13.464-69.828-16.339-105.327c-5.758-71.036-3.157-142.989-0.93-215.153 c2.119-72.183,3.674-144.733,1.769-217.224c-0.839-36.243-2.432-72.47-4.776-108.653c-1.051-18.097-2.508-36.172-3.927-54.248 c-1.62-18.064-3.355-36.117-5.26-54.154c-7.776-72.141-18.097-144.042-31.033-215.561c-13.334-71.465-28.86-142.6-47.533-213.099 c-0.534-2.016-2.858-3.275-5.191-2.814C558.212,675.036,556.773,676.951,557.181,678.906z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M776.315,2006.208c-14.687,15.583-40.515,11.102-49.349-8.404 c-48.75-107.625-159.066-424.383,23.125-789.305c153.853-308.16,207.994-489.878,226.856-574.074 c3.989-17.804,28.388-20.168,35.752-3.475C1093.952,815.121,1308.496,1441.568,776.315,2006.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M749.638,1994.851c-0.523,0.094-1.06,0.138-1.611,0.129c-4.616-0.071-8.302-3.87-8.231-8.487 c0.081-5.234,10.266-528.36,204.832-966.5c1.874-4.216,6.812-6.118,11.035-4.248c4.22,1.875,6.121,6.814,4.248,11.036 c-193.151,434.95-203.318,954.77-203.398,959.968C756.452,1990.816,753.497,1994.16,749.638,1994.851z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047745691779946369230000015260694915010810798_",
    gradientUnits: "userSpaceOnUse",
    x1: -954.307,
    y1: 2769.646,
    x2: -387.513,
    y2: 1069.2594,
    gradientTransform: "matrix(-1 0 0 1 1155.7772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047745691779946369230000015260694915010810798_)"
    },
    d: "M646.576,2831.331 c0,24.385,19.971,44.336,44.379,44.336h2399.856c24.409,0,44.38-19.951,44.38-44.336L3155.16,1452.2 c0-24.385-28.73-71.991-81.383-68.414l-2345.404-60.687c-30.626-0.793-60.238,10.996-81.925,32.612 c-21.687,21.617-33.554,51.172-32.83,81.77L646.576,2831.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M690.39,2788.795c0,23.092,18.893,41.986,41.986,41.986h2300.562 c23.092,0,41.986-18.894,41.986-41.986l18.844-1251.988c-2.219-75.342-68.273-102.42-108.313-100.821l-2247.923-60.308 c-21.516-0.577-42.325,7.707-57.558,22.913s-23.553,36.001-23.013,57.518L690.39,2788.795z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M3050.062,2193.549c-0.029,0-0.057,0-0.084,0c-3.144-0.046-5.654-2.635-5.606-5.776l1.49-101.533 c0.046-3.14,2.624-5.424,5.77-5.606c3.144,0.045,5.654,2.635,5.606,5.776l-1.491,101.533 C3055.701,2191.055,3053.163,2193.549,3050.062,2193.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M3053.716,1944.737c0,0-0.056,0-0.085,0c-3.143-0.046-5.654-2.636-5.606-5.776l5.711-388.878 c-0.108-23.239-7.168-41.794-20.985-55.031c-25.747-24.671-66.594-23.393-68.341-23.342l-718.435-19.264 c-3.14-0.08-5.616-2.698-5.535-5.838c0.083-3.09,2.612-5.538,5.685-5.538c0.051,0,0.102,0,0.156,0.006l718.04,19.264 c4.456-0.21,47.603-1,76.301,26.494c16.128,15.459,24.369,36.756,24.491,63.306l-5.713,388.992 C3059.356,1942.244,3056.817,1944.737,3053.716,1944.737z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065752734186881629200000003328834110455545759_",
    gradientUnits: "userSpaceOnUse",
    x1: 1866.5566,
    y1: 1354.4985,
    x2: 1866.5566,
    y2: 2083.5793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065752734186881629200000003328834110455545759_)"
    },
    d: "M458.538,2990.152h2816.038 c3.657,0,6.648-2.992,6.648-6.648v-107.878c0-3.657-2.992-6.648-6.648-6.648H458.538c-3.657,0-6.648,2.992-6.648,6.648v107.878 C451.889,2987.161,454.881,2990.152,458.538,2990.152z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100375869953913201070000006658352101578481343_",
    gradientUnits: "userSpaceOnUse",
    x1: 1013.3232,
    y1: 1474.0986,
    x2: 856.8647,
    y2: 2055.6016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000100375869953913201070000006658352101578481343_)"
    },
    cx: 970.335,
    cy: 1633.871,
    r: 164.229
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.86
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M970.335,1737.009c-55.449,0-100.559-45.111-100.559-100.559 c0-55.448,45.11-100.559,100.559-100.559c55.448,0,100.559,45.11,100.559,100.559 C1070.894,1691.898,1025.784,1737.009,970.335,1737.009z M970.335,1552.742c-46.157,0-83.708,37.551-83.708,83.708 c0,46.156,37.551,83.707,83.708,83.707c46.156,0,83.707-37.551,83.707-83.707 C1054.043,1590.293,1016.492,1552.742,970.335,1552.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M938.833,1675.176v-72.294 c0-7.725,8.409-12.513,15.052-8.571l60.918,36.147c6.507,3.861,6.507,13.28,0,17.142l-60.918,36.147 C947.242,1687.689,938.833,1682.901,938.833,1675.176z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183955425791531242400000017546592783366737043_",
    gradientUnits: "userSpaceOnUse",
    x1: 2789.7219,
    y1: 1271.9104,
    x2: 2483.1719,
    y2: 1864.5734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000183955425791531242400000017546592783366737043_)"
    },
    cx: 2714.71,
    cy: 1416.932,
    r: 141.905
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.87,
      fill: "#FFFFFF"
    },
    d: "M2739.385,1328.68c-3.938-1.399-8.07,1.556-8.07,5.735v8.562v16.787v83.457 c-8.248-6.786-19.764-11.016-32.53-11.016c-25.071,0-45.394,16.259-45.394,36.315c0,20.056,20.324,36.315,45.394,36.315 c25.071,0,45.395-16.259,45.395-36.315c0-0.175-0.03-0.343-0.033-0.517h0.033v-108.167c17.982,2.724,30.2,16.379,37.352,27.533 c3.003,4.683,10.205,2.315,9.91-3.24C2789.654,1350.419,2755.365,1334.358,2739.385,1328.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093152486774578188110000007747272697529333936_",
    gradientUnits: "userSpaceOnUse",
    x1: -8423.1465,
    y1: -577.6664,
    x2: -7587.8882,
    y2: -577.6664,
    gradientTransform: "matrix(0 -1 -1 0 572.4961 -5339.314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093152486774578188110000007747272697529333936_)"
    },
    d: "M1735.013,3070.17 c-207.521,4.398-923.337,18.66-1177,11.851c-26.873-0.721-48.442-19.137-49.322-42.107 c-4.349-113.612-15.373-530.11-6.253-715.941c1.9-38.706,38.577-69.487,83.888-70.29 c217.819-3.862,830.463-12.381,1111.115,7.869c33.626,2.427,60.404,24.988,63.763,53.69 c14.48,123.729,49.875,542.017,37.687,702.565C1796.692,3046.762,1768.946,3069.451,1735.013,3070.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1671.344,3019.476c-167.5,6.115-724.733,25.405-930.786,19.282 c-30.118-0.894-54.47-21.185-56.231-46.901c-7.249-105.882-23.231-467.122-8.683-622.424 c2.62-27.964,29.077-49.909,61.849-51.418c170.884-7.87,689.747-30.466,893.491-24.598 c32.503,0.937,59.047,22.458,61.955,50.147c12.031,114.546,40.659,498.406,32.235,630.376 C1723.593,2998.713,1700.342,3018.418,1671.344,3019.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1762.629,2789.388L1762.629,2789.388c-6.368,0-11.62-4.242-11.952-9.677 c-1.644-26.834-6.296-102.428-8.588-136.212c-0.453-6.66,6.552-11.889,14.217-10.626l1.307,0.216 c5.229,0.863,9.166,4.57,9.652,9.103c2.448,22.836,9.236,91.743,7.329,137.398 C1774.365,2785.074,1769.048,2789.388,1762.629,2789.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070083232364453640240000011118944986598474936_",
    gradientUnits: "userSpaceOnUse",
    x1: 1095.6431,
    y1: 2673.4099,
    x2: 1425.8998,
    y2: 2673.4099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070083232364453640240000011118944986598474936_)"
    },
    d: "M1425.9,2758.681 c0,91.198-73.931,165.128-165.128,165.128l0,0c-91.198,0-165.128-73.93-165.128-165.128v-170.542 c0-91.198,73.931-165.129,165.128-165.129l0,0c91.198,0,165.128,73.931,165.128,165.129V2758.681z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1259.944,2849.741c-1.364,0.001-1.661-0.249-2.982-0.763 c-4.305-1.676-6.061-5.821-6.061-10.439v-143.954l-60.283,57.26c-4.449,4.3-12.08,4.181-16.38-0.264 c-4.302-4.448-4.452-11.54-0.005-15.841l66.263-64.216l-66.182-64.061c-4.444-4.306-4.589-11.398-0.284-15.841 c4.306-4.443,12.46-4.554,16.903-0.25l59.968,57.076v-145.582c0-4.639,1.781-8.799,6.113-10.46 c4.331-1.663,8.7-0.479,11.803,2.972l79.211,88.429c4.03,4.483,3.654,11.35-0.678,15.541l-74.708,72.189l74.615,72.329 c4.358,4.223,4.544,11.148,0.442,15.619l-79.489,86.626C1266.045,2848.471,1263.023,2849.741,1259.944,2849.741z  M1274.863,2701.355v108.404l52.653-57.386L1274.863,2701.355z M1274.863,2532.09v109.657l52.727-50.995L1274.863,2532.09z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000901963189411668830000017473996288970482357_",
    gradientUnits: "userSpaceOnUse",
    x1: 1627.3477,
    y1: 2793.4775,
    x2: 2186.2522,
    y2: 2793.4775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000901963189411668830000017473996288970482357_)"
    },
    d: "M1636.489,2402.13 c-2.942,138.861-12.485,617.842-7.929,787.578c0.482,17.983,12.804,32.415,28.175,33.003 c76.022,2.911,354.717,10.287,479.065,4.185c25.899-1.271,46.495-25.814,47.033-56.133 c2.584-145.752,8.285-555.696-5.265-743.492c-1.624-22.501-16.72-40.42-35.927-42.667 c-82.792-9.69-362.686-33.373-470.115-25.218C1652.152,2360.858,1636.971,2379.424,1636.489,2402.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1670.41,2444.734c-4.091,112.081-16.999,484.948-12.903,622.826 c0.599,20.153,14.176,36.448,31.385,37.625c70.849,4.851,312.57,15.546,416.488,5.811c18.712-1.753,33.396-19.457,34.406-41.386 c5.266-114.345,20.386-461.537,16.459-597.871c-0.626-21.748-15.027-39.51-33.554-41.456 c-76.649-8.052-333.504-27.207-421.811-21.571C1684.304,2409.771,1671.12,2425.33,1670.41,2444.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1824.372,2383.652L1824.372,2383.652c0,4.261,2.838,7.775,6.476,7.997 c17.956,1.1,68.538,4.213,91.145,5.748c4.457,0.302,7.956-4.385,7.11-9.513l-0.145-0.876c-0.577-3.499-3.057-6.133-6.091-6.458 c-15.28-1.638-61.388-6.18-91.938-4.905C1827.258,2375.798,1824.372,2379.356,1824.372,2383.652z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067224170110494218590000003068131815570426012_",
    gradientUnits: "userSpaceOnUse",
    x1: 1758.0135,
    y1: 2793.7886,
    x2: 2023.4492,
    y2: 2793.7886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067224170110494218590000003068131815570426012_)"
    },
    d: "M2023.449,2862.323 c0,73.298-59.42,132.718-132.718,132.718l0,0c-73.298,0-132.717-59.42-132.717-132.718v-137.069 c0-73.298,59.419-132.718,132.717-132.718l0,0c73.298,0,132.718,59.42,132.718,132.718V2862.323z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1890.066,2935.511c-1.096,0.001-0.648-0.2-1.709-0.614c-3.46-1.347-4.184-4.678-4.184-8.39 v-115.699l-49.138,46.021c-3.576,3.456-10.052,3.36-13.509-0.213c-3.456-3.574-3.75-9.274-0.176-12.732l53.172-51.611 l-53.235-51.487c-3.571-3.461-3.71-9.161-0.249-12.732c3.46-3.57,10.691-3.66,14.262-0.2l48.874,45.873V2656.72 c0-3.729,0.745-7.073,4.226-8.408c3.481-1.336,6.649-0.385,9.143,2.389l63.492,71.073c3.238,3.603,2.851,9.122-0.631,12.49 l-60.089,58.02l59.948,58.133c3.502,3.394,3.642,8.96,0.345,12.553l-63.893,69.624 C1894.975,2934.49,1892.541,2935.511,1890.066,2935.511z M1904.711,2816.25v87.127l42.318-46.123L1904.711,2816.25z  M1904.711,2680.206v88.135l42.378-40.986L1904.711,2680.206z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151534509293000877370000006289823799920718488_",
    gradientUnits: "userSpaceOnUse",
    x1: 2959.3516,
    y1: 1546.7454,
    x2: 2683.6292,
    y2: 2195.6672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000151534509293000877370000006289823799920718488_)"
    },
    cx: 2877.438,
    cy: 1739.532,
    r: 154.709
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.87,
      fill: "#FFFFFF"
    },
    d: "M2876.837,1810.71c-30.894-16.023-61.788-16.023-92.682,0v-141.512 c30.894-15.287,61.788-15.287,92.682,0V1810.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.87,
      fill: "#FFFFFF"
    },
    d: "M2880.956,1810.71c30.894-16.023,61.787-16.023,92.681,0v-141.512 c-30.894-15.287-61.788-15.287-92.681,0V1810.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065060386296865211220000015594180032148240550_",
    gradientUnits: "userSpaceOnUse",
    x1: 1366.5542,
    y1: 1230.1832,
    x2: 1119.5597,
    y2: 1951.2955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000065060386296865211220000015594180032148240550_)"
    },
    cx: 1302.475,
    cy: 1417.265,
    r: 157.706
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1401.517,1498.883c0,3.136-2.542,5.678-5.678,5.678H1201.81c-3.136,0-5.678-2.542-5.678-5.678 v-159.798c0-3.136,2.542-5.678,5.678-5.678h194.029c3.136,0,5.678,2.542,5.678,5.678V1498.883z M1209.824,1494.292h184.847 v-150.616h-184.847V1494.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1354.923,1391.598c-1.557-2.021-4.232-3.211-6.783-3.227c-2.551-0.016-5.104,1.143-6.687,3.143 l-41.84,52.764c-1.438,1.816-3.604,2.948-5.914,3.12c-2.31,0.173-4.603-0.629-6.295-2.212l-31.87-29.806 c-3.149-2.946-7.099-2.984-10.293-0.089l-38.839,36.042v46.382h195.116v-46.382L1354.923,1391.598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9966 -0.0825 0.0825 0.9966 -109.0804 108.4253)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 1257.761,
    cy: 1374.443,
    rx: 20.11,
    ry: 20.11
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137821183810278218670000014317648029364077222_",
    gradientUnits: "userSpaceOnUse",
    x1: 2117.3499,
    y1: 1692.803,
    x2: 2222.6094,
    y2: 1954.8787,
    gradientTransform: "matrix(-1 0 0 1 3269.0122 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137821183810278218670000014317648029364077222_)"
    },
    d: "M762.722,2304.328 c16.08-26.79,20.246-50.819,15.493-81.888c-7.846-51.286-1.733-108.402,30.948-150.606 c31.002-40.038,86.806-43.613,120.858-79.336c0.236-0.247,1.022-1.412,2.162-3.208c8.605-13.553,13.325-28.969,13.856-45.015 c3.326-100.52,76.447-99.347,111.139-80.276c54.927,30.194,42.868,86.54,42.868,86.54c-15.325,16.386-70.06-18.539-70.06-18.539 l-22.751,36.523c6.449,2.804,13.378,5.973,20.917,9.669c51.55,25.275,57.069,222.747,28.038,254.332 c-29.031,31.584-34.138,61.734-4.853,113.415c29.285,51.681,12.35,119.164-143.468,175.155 c-25.237,9.069-63.232,10.045-88.16-0.067c-54.678-22.18-84.752-87.204-86.232-143.231 C732.727,2349.362,748.788,2327.542,762.722,2304.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M803.113,2239.948c-0.438,0-0.812-0.334-0.852-0.779c-6.415-71.479,15.454-118.555,34.926-145.459 c24.493-33.84,53.125-48.533,66.182-51.881c28.628-7.338,42.02-41.085,42.15-41.425c0.174-0.443,0.665-0.665,1.11-0.488 c0.438,0.171,0.659,0.665,0.488,1.107c-0.137,0.348-13.833,34.906-43.32,42.464c-16.644,4.267-44.153,22.118-65.222,51.226 c-19.302,26.669-40.977,73.352-34.609,144.303c0.043,0.471-0.304,0.887-0.776,0.929 C803.163,2239.946,803.136,2239.948,803.113,2239.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M828.545,2490.748c-0.104,0-0.207-0.018-0.311-0.058c-0.625-0.242-62.585-25.08-61.512-93.792 c0.007-0.473,0.358-0.916,0.869-0.843c0.471,0.007,0.849,0.396,0.842,0.869c-1.056,67.534,59.807,91.932,60.422,92.171 c0.438,0.171,0.659,0.667,0.488,1.107C829.21,2490.54,828.889,2490.748,828.545,2490.748z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012455885426173206690000001426302220739338900_",
    gradientUnits: "userSpaceOnUse",
    x1: 965.0222,
    y1: 2154.1724,
    x2: 904.9763,
    y2: 2376.3423,
    gradientTransform: "matrix(1 0 0 1 204.5823 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012455885426173206690000001426302220739338900_)"
    },
    d: "M1206.564,2238.77 c0,0-67.471,80.804-135.413,15.183l-26.25,60.875c0,0,99.216,76.825,174.474-44.051L1206.564,2238.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155845589176385711420000016166570361501848990_",
    gradientUnits: "userSpaceOnUse",
    x1: 1726.5416,
    y1: 1895.5348,
    x2: 1382.5394,
    y2: 2070.103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155845589176385711420000016166570361501848990_)"
    },
    d: "M1039.92,2088.762 c-18.73-5.615-73.263-15.982-125.134,31.887c-8.797,8.119-12.393,20.455-9.255,32.007c13.932,51.292,50.691,202.832,18.46,268.4 c0,0,56.799,62.613,118.765,12.148c0,0,27.802-121.172,64.218-174.367c25.141-36.725-40.09-137.908-56.593-162.353 C1047.88,2092.783,1044.197,2090.044,1039.92,2088.762z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121983654670998820760000015108522404071051924_",
    gradientUnits: "userSpaceOnUse",
    x1: -5822.9282,
    y1: 3220.3923,
    x2: -5807.938,
    y2: 3113.9614,
    gradientTransform: "matrix(-0.9887 0.1503 0.1503 0.9887 -5206.5879 -161.5951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121983654670998820760000015108522404071051924_)"
    },
    d: "M1010.907,1990.984 c0,0-37.795,74.01-44.421,107.998c0,0,28.509,17.838,60.204-1.646c0,0,13.325-77.175,19.51-90.489L1010.907,1990.984z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001659300141449679020000011036895235604788101_",
    gradientUnits: "userSpaceOnUse",
    x1: 5021.6187,
    y1: 3349.9216,
    x2: 5356.0298,
    y2: 2759.6135,
    gradientTransform: "matrix(1 -0.0095 0.0095 1 -4268.8198 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001659300141449679020000011036895235604788101_)"
    },
    d: "M1115.093,2687.618 c-0.212,5.5,9.446,49.134,14.702,72.408c2.116,9.365,0.643,19.165-4.126,27.497l-182.035,306.375 c-2.203,3.706-3.805,7.72-4.779,11.919c-3.336,14.377-10.255,49.613-6.642,81.668l9.416,19.558l-40.727-9.247l-8.861-109.372 l11.53-7.031c9.96-6.073,17.716-15.152,22.157-25.94c16.46-39.982,57.335-141.76,67.872-191.361 c11.974-56.372,74.573-102.158,74.573-102.158l-10.998-26L1115.093,2687.618z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091705059849284902810000008275892345534496187_",
    gradientUnits: "userSpaceOnUse",
    x1: 5094.5181,
    y1: 3141.2139,
    x2: 5192.2676,
    y2: 3141.2139,
    gradientTransform: "matrix(1 -0.0095 0.0095 1 -4268.8198 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091705059849284902810000008275892345534496187_)"
    },
    d: "M855.639,3160.161 c0,0,21.993-34.868,24.581-48.442c2.588-13.573,9.791-37.541,23.351-30.326c0,0,6.389,65.933,4.187,91.697 c-2.202,25.762,29.124,24.934,29.124,24.934s8.634,1.214,14.956,7.534c4.367,4.366,1.244,11.939-4.916,12.335 c-10.252,0.661-26.535,0.833-43.632-2.47c-5.976-1.154-10.405-6.239-10.767-12.315l-4.513-75.884l-27.742,35.031 L855.639,3160.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152236358932410485590000012906085721018739607_",
    gradientUnits: "userSpaceOnUse",
    x1: 5400.5894,
    y1: 2913.2266,
    x2: 4900.4629,
    y2: 3073.1506,
    gradientTransform: "matrix(1 -0.0095 0.0095 1 -4268.8198 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152236358932410485590000012906085721018739607_)"
    },
    d: "M1006.348,2736.42 c0,0-6.42,274.05-7.29,312.972c-0.869,38.923,6.146,125.177,45.165,150.959l-16.979,12.57c0,0-21.218-18.033-41.948-52.741 c-23.287-38.99-30.328-46.114-30.328-46.114l7.727-15.825c3.384-6.928,4.378-14.765,2.82-22.316 c-8.42-40.81-36.549-176.547-44.222-205.779c-9.058-34.506-9.701-80.586,21.81-119.158 C974.613,2712.418,1006.348,2736.42,1006.348,2736.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049203799804862448360000014595257488778118283_",
    gradientUnits: "userSpaceOnUse",
    x1: 5185.1445,
    y1: 3158.8682,
    x2: 5301.6709,
    y2: 3158.8682,
    gradientTransform: "matrix(1 -0.0095 0.0095 1 -4268.8198 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049203799804862448360000014595257488778118283_)"
    },
    d: "M970.317,3225.273 c-1.21,0.011-2.239-0.855-2.41-2.054c-1.299-9.136-6.703-45.765-11.127-55.25c-5.068-10.862-21.618-56.58,0.009-60.461 c0,0,53.766,78.553,64.087,89.143c10.321,10.592,23.347,3.7,23.347,3.7s10.056,2.971,17.639,12.662 c3.609,4.612,0.247,11.383-5.61,11.439l-36.215,0.346c-10.517,0.1-19.977-6.289-23.887-16.053 c-6.375-15.922-17.325-39.277-30.088-49.638l6.631,63.5C972.842,3224.023,971.74,3225.26,970.317,3225.273L970.317,3225.273z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129198368987764148940000008333610410948550556_",
    gradientUnits: "userSpaceOnUse",
    x1: 5346.5566,
    y1: 2376.2141,
    x2: 5067.3955,
    y2: 2998.512,
    gradientTransform: "matrix(1 -0.0095 0.0095 1 -4268.8198 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129198368987764148940000008333610410948550556_)"
    },
    d: "M1051.327,2403.656 c0,0-8.16,26.012,4.377,68.855l77.774,271.591c1.222,4.268-1.081,8.734-5.259,10.233c-23.263,8.35-99.738,31.948-204.135,24.752 c-5.255-0.363-9.663-4.084-10.806-9.227c-6.879-30.962-30.349-136.602-35.18-158.308 c-18.413-82.708-36.245-161.364,54.201-215.298C973.981,2414.108,1010.13,2414.093,1051.327,2403.656z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080190728957398013750000012841452733242427804_",
    gradientUnits: "userSpaceOnUse",
    x1: 849.6028,
    y1: 2240.0923,
    x2: 1106.7418,
    y2: 2240.0923,
    gradientTransform: "matrix(1 0 0 1 204.5823 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080190728957398013750000012841452733242427804_)"
    },
    d: "M957.51,2157.735 c0,0-15.656,223.726,128.893,111.355c0,0,21.348-20.166,36.76-22.619c8.302-1.321,17.668-2.203,24.543-2.736 c3.137-0.243,4.604,3.808,2.03,5.617c-4.965,3.488-11.471,7.244-17.114,7.83c-10.905,1.131,0.721,9.122-11.154,30.002 c-11.875,20.881-28.838,13.006-28.838,13.006s-165.625,169.611-198.693-126.201 C892.768,2118.958,945.719,2121.885,957.51,2157.735z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013190576506920244710000003126389890170590130_",
    gradientUnits: "userSpaceOnUse",
    x1: -7028.7803,
    y1: 1731.949,
    x2: -7072.2783,
    y2: 1777.9236,
    gradientTransform: "matrix(-0.9865 -0.1635 -0.2088 1.2596 -5389.312 -1140.5688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013190576506920244710000003126389890170590130_)"
    },
    d: "M1250.922,2183.157l-49.175-6.479 c-5.863-0.972-11.915,2.464-15.538,8.819l-32.348,71.501c-6.09,10.683-1.758,24.856,8.096,26.49l39.488,5.065 c3.778,0.626,7.662-1.759,9.794-6.015l43.749-87.321C1257.515,2190.172,1255.401,2183.899,1250.922,2183.157z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060735667499909792070000010704348440797216132_",
    gradientUnits: "userSpaceOnUse",
    x1: 1031.3711,
    y1: 2177.6616,
    x2: 999.726,
    y2: 2294.7485,
    gradientTransform: "matrix(1 0 0 1 204.5823 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060735667499909792070000010704348440797216132_)"
    },
    d: "M1217.372,2279.601 c0,0,33.063-48.117,29.222-54.041c-3.841-5.924-32.825-14.411-39.63-16.413 C1200.159,2207.145,1187.349,2250.778,1217.372,2279.601z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168102563729368960620000002638105589356438182_",
    gradientUnits: "userSpaceOnUse",
    x1: -6781.8208,
    y1: 3415.0325,
    x2: -6641.6577,
    y2: 3576.1824,
    gradientTransform: "matrix(-0.9609 -0.2771 -0.2771 0.9609 -4478.9717 -3190.0432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168102563729368960620000002638105589356438182_)"
    },
    d: "M1095.63,1949.266 c0,0,7.043,124.415-45.301,126.159c-52.344,1.744-57.422-86.72-57.422-86.72s15.452-55.888,40.371-62.404 C1058.196,1919.785,1095.63,1949.266,1095.63,1949.266z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070092155350148672440000005217024569809612478_",
    gradientUnits: "userSpaceOnUse",
    x1: 2118.4424,
    y1: 1689.9703,
    x2: 2223.9641,
    y2: 1952.6986,
    gradientTransform: "matrix(-1 0 0 1 3269.0122 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070092155350148672440000005217024569809612478_)"
    },
    d: "M1080.237,1910.865 c0,0,23.915,24.454,19.809,39.675c-4.107,15.221-55.405-0.696-68.051-7.886l-42.376,45.102c0,0,1.299-66.816,30.534-87.391 C1049.387,1879.789,1080.237,1910.865,1080.237,1910.865z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004519169574496701190000017357965388219723186_",
    gradientUnits: "userSpaceOnUse",
    x1: -6746.8013,
    y1: 3384.5735,
    x2: -6606.6401,
    y2: 3545.7212,
    gradientTransform: "matrix(-0.9609 -0.2771 -0.2771 0.9609 -4478.9717 -3190.0432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004519169574496701190000017357965388219723186_)"
    },
    d: "M1008.764,1989.906 c0,0-6.379-42.674-27.238-30.675c-20.86,11.999,1.53,45.071,17.826,43.008L1008.764,1989.906z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1737.497,1252.581c134.743-118.273,340.574-104.873,458.846,29.869 c7.329,8.354,14.11,16.988,20.394,25.864c8.451,11.939,25.686,13.032,35.138,1.862l30.901-36.526 c6.75-7.971,6.912-19.516,0.624-27.855c-5.962-7.899-12.233-15.648-18.865-23.201 c-151.272-172.337-414.562-189.475-586.893-38.205c-13.061,11.455-25.172,23.595-36.407,36.27 c-8.411,9.489-7.321,24.06,2.526,32.056l36.221,29.4c9.162,7.441,22.502,6.356,30.345-2.464 C1718.729,1270.204,1727.75,1261.137,1737.497,1252.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1579.445,1120.916c231.883-203.535,586.099-180.481,789.636,51.401 c0.06,0.068,0.118,0.133,0.176,0.199c8.896,10.151,24.641,10.232,33.363-0.075l30.31-35.828 c-0.085-11.082-0.141-18.22-0.224-29.305c-237.238-264.653-645.372-289.603-913.119-54.586 c-23.371,20.516-44.804,42.413-64.466,65.376c-7.995,9.348-6.447,23.531,3.103,31.281l36.127,29.327 c9.199,7.468,22.749,6.456,30.476-2.525C1541.511,1156.778,1559.671,1138.271,1579.445,1120.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1421.389,975.558c320.452-281.281,805.513-257.414,1097.37,48.016 c9.164,9.587,24.5,9.39,33.068-0.738l30.081-35.555c7.302-8.631,7.03-21.516-0.826-29.645 c-325.545-337.202-863.632-362.681-1219.55-50.273c-33.429,29.35-63.943,60.774-91.814,93.787 c-7.941,9.409-6.404,23.591,3.158,31.353l36.08,29.294c9.413,7.636,23.062,6.161,30.893-3.083 C1364.627,1029.456,1391.729,1001.599,1421.389,975.558z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096752934092452721870000004120655887565334670_",
    gradientUnits: "userSpaceOnUse",
    x1: 1655.0356,
    y1: 1717.2426,
    x2: 2260.5239,
    y2: 1717.2426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096752934092452721870000004120655887565334670_)"
    },
    d: "M2260.524,1873.578 c0,167.201-135.543,302.744-302.744,302.744l0,0c-167.201,0-302.744-135.543-302.744-302.744v-312.67 c0-167.201,135.543-302.744,302.744-302.744l0,0c167.201,0,302.744,135.543,302.744,302.744V1873.578z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1956.262,2040.526c-2.501,0.002-3.416-0.456-5.838-1.399 c-7.893-3.072-11.482-10.672-11.482-19.14v-263.922l-110.151,104.979c-8.156,7.884-21.962,7.665-29.846-0.485 c-7.886-8.155-8.07-21.157,0.083-29.043l121.533-117.732l-121.314-117.448c-8.147-7.894-8.401-20.896-0.508-29.042 c7.894-8.145,22.479-8.349,30.624-0.458l109.579,104.643v-266.907c0-8.506,3.637-16.133,11.579-19.178 c7.939-3.049,16.136-0.879,21.825,5.449l145.317,162.125c7.388,8.219,6.746,20.809-1.197,28.493l-136.947,132.351 l136.81,132.608c7.99,7.742,8.337,20.438,0.815,28.635l-145.731,158.819 C1967.445,2038.198,1961.908,2040.526,1956.262,2040.526z M1980.019,1768.478v198.746l96.533-105.212L1980.019,1768.478z  M1980.019,1458.148v201.045l96.669-93.493L1980.019,1458.148z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087388023274043893010000011553993256624725930_",
    gradientUnits: "userSpaceOnUse",
    x1: -328.3249,
    y1: 2050.6978,
    x2: -378.701,
    y2: 2121.7732,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087388023274043893010000011553993256624725930_)"
    },
    d: "M2393.078,2090.624 c0,0,7.075-12.798,6.315-23.094c-0.76-10.296,5.656-25.417-1.172-24.299c-6.827,1.119-8.237,0.206-10.09,12.561 C2386.278,2068.147,2369.608,2113.719,2393.078,2090.624z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121975483716999330250000003312855430272793756_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.3899,
    y1: 3192.4895,
    x2: 49.5557,
    y2: 3482.8843,
    gradientTransform: "matrix(1 0 0 1 2424.4246 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121975483716999330250000003312855430272793756_)"
    },
    d: "M2722.803,3266.654 c-24.87-0.697-37.734-3.625-44.385-6.343c-0.015,2.473-0.001,4.99,0.079,7.597c0.086,2.785,2.149,5.01,4.687,4.993 l136.554-0.881c4.358-0.028,6.905-5.083,5.016-9.078C2806.849,3264.42,2761.248,3267.73,2722.803,3266.654z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124124128911303941870000001793149384706440864_",
    gradientUnits: "userSpaceOnUse",
    x1: -685.8312,
    y1: 2562.5513,
    x2: -674.4207,
    y2: 2078.7546,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124124128911303941870000001793149384706440864_)"
    },
    d: "M2684.247,3214.296 c3.127-11.104,13.38-18.637,24.91-18.273l11.404,0.361c60.694,14.553,91.409,48.107,103.468,64.958 c0.234,0.327,0.375,0.682,0.541,1.03c-17.905,1.48-63.505,4.789-101.95,3.713c-24.871-0.696-37.734-3.625-44.385-6.343 C2678.348,3240.325,2681.213,3225.065,2684.247,3214.296z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158714560031226649880000009934012636715367103_",
    gradientUnits: "userSpaceOnUse",
    x1: -663.9413,
    y1: 3113.0127,
    x2: -683.3598,
    y2: 3282.4839,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158714560031226649880000009934012636715367103_)"
    },
    d: "M2739.735,3157.204l-9.537,45.913 c-0.699,3.365-3.284,5.884-6.415,6.178c-3.833,0.36-9.289,0.571-14.776-0.235c-4.92-0.723-8.347-5.723-7.474-11.089l6.629-40.767 H2739.735z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155829118742895993740000011886494131778456462_",
    gradientUnits: "userSpaceOnUse",
    x1: -372.0176,
    y1: 3192.4895,
    x2: -741.8519,
    y2: 3482.8843,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155829118742895993740000011886494131778456462_)"
    },
    d: "M2542.125,3266.654 c24.87-0.697,37.734-3.625,44.385-6.343c0.015,2.473,0.001,4.99-0.079,7.597c-0.086,2.785-2.149,5.01-4.686,4.993 l-136.554-0.881c-4.358-0.028-6.905-5.083-5.016-9.078C2458.079,3264.42,2503.68,3267.73,2542.125,3266.654z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001633804251933393300000018090580874305126554_",
    gradientUnits: "userSpaceOnUse",
    x1: -447.9063,
    y1: 2568.1633,
    x2: -436.4957,
    y2: 2084.3674,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001633804251933393300000018090580874305126554_)"
    },
    d: "M2440.174,3262.941 c0.165-0.348,0.306-0.702,0.541-1.03c12.06-16.85,42.775-50.405,103.469-64.958l29.116-0.919c0,0,12.965,22.534,13.21,64.276 c-6.65,2.718-19.514,5.647-44.385,6.343C2503.68,3267.73,2458.079,3264.42,2440.174,3262.941z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096754178984101862650000006986186165484819331_",
    gradientUnits: "userSpaceOnUse",
    x1: -505.7641,
    y1: 3131.1372,
    x2: -525.1825,
    y2: 3300.6082,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096754178984101862650000006986186165484819331_)"
    },
    d: "M2578.698,3151.908 c-0.323,2.17-4.314,35.156-5.859,47.945c-0.367,3.04-2.568,5.391-5.344,5.723c-4.958,0.592-12.981,1.131-20-0.308 c-3.787-0.776-6.528-4.414-6.528-8.644v-51.778L2578.698,3151.908z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051354799846967680660000016687878287612755627_",
    gradientUnits: "userSpaceOnUse",
    x1: -610.9796,
    y1: 2591.9585,
    x2: -610.9796,
    y2: 3382.6626,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051354799846967680660000016687878287612755627_)"
    },
    d: "M2602.058,2549.935 c0,0-70.227,266.887-68.957,602.737c0.023,6.123,4.323,11.408,10.314,12.67c8.83,1.859,21.809,4.068,32.554,3.767 c5.736-0.161,10.531-4.415,11.496-10.071c9.846-57.746,66.356-383.056,98.552-435.868c0,0,21.183,289.735,14.412,440.052 c-0.168,3.738,2.569,6.98,6.285,7.409c5.638,0.652,14.657,1.147,26.135-0.073c4.357-0.463,7.873-3.756,8.495-8.094 c7.013-48.872,47.384-339.774,45.667-549.329c-0.097-11.817-31.252-63.2-31.252-63.2H2602.058z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134950616026847665400000008494951776152233130_",
    gradientUnits: "userSpaceOnUse",
    x1: -772.8755,
    y1: 2251.5886,
    x2: -704.784,
    y2: 2056.1003,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134950616026847665400000008494951776152233130_)"
    },
    d: "M2820.972,2317.822 c19.089-52.242,12.164-115.325,12.092-115.956l-5.26,0.601c0.07,0.619,6.847,62.492-11.807,113.537L2820.972,2317.822z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098216587802460322960000011208396169910051476_",
    gradientUnits: "userSpaceOnUse",
    x1: -319.4807,
    y1: 2352.0684,
    x2: -433.7183,
    y2: 3063.2905,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098216587802460322960000011208396169910051476_)"
    },
    d: "M2331.648,2339.675 c-15.76-85.741,6.856-227.049,6.856-227.049l30.806,31.926c0,0,5.201,115.352,27.132,163.089 C2382.008,2309.362,2354.026,2315.807,2331.648,2339.675z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124849516822423129600000005774629234686417280_",
    gradientUnits: "userSpaceOnUse",
    x1: 2946.8906,
    y1: 2052.1226,
    x2: 2649.0972,
    y2: 2370.4541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124849516822423129600000005774629234686417280_)"
    },
    d: "M2396.442,2307.642 c4.14,9.011,8.873,15.622,14.283,18.584c19.802,10.873,58.219-51.167,86.85-104.938c20.592-38.647,36.144-73.011,36.144-73.011 c20.592-23.261,71.595-26.457,119.04-23.492c49.388,3.064,94.856,12.784,98.151,13.509c0.132,0.033,0.198,0.033,0.198,0.033 c22.734,2.998,42.469,5.502,56.736,7.314c16.671,2.108,31.926,10.345,42.931,23.063 c43.59,50.442,139.269,188.592,26.655,327.795c-14.398-8.006-34.892-20.823-48.795-35.682 c12.454-35.122,13.476-79.997-12.619-135.052c-0.889,4.382-2.01,8.698-3.328,12.949 c-36.011,113.999-37.923,208.888-37.823,230.731c0,2.999-1.78,5.667-4.547,6.755c-47.346,18.978-138.544,7.677-169.12,3.13 c-5.634-0.824-9.39-6.062-8.632-11.696c9.126-66.126-15.782-158.182-41.283-230.304 c-149.646,148.297-203.096,92.305-219.631,2.346C2354.026,2315.807,2382.008,2309.362,2396.442,2307.642z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134220127996941669000000017572868987921980836_",
    gradientUnits: "userSpaceOnUse",
    x1: -828.3424,
    y1: 2554.5564,
    x2: -656.415,
    y2: 2554.5564,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134220127996941669000000017572868987921980836_)"
    },
    d: "M2744.987,2556.508 c12.997-7.292,63.4-38.594,83.655-95.693c13.908,14.845,34.386,27.673,48.796,35.672c-21.52,26.6-50.64,53.239-89.19,79.312l0,0 c-1.367,29.667-24.172,40.65-29.389,50.26c-5.216,9.61,2.197,7.413-1.098,19.494s-37.89-19.22-46.127-26.358 c-8.237-7.139-3.295-26.907-3.295-26.907s-0.549-4.118-2.746-12.355C2703.402,2571.713,2744.817,2556.57,2744.987,2556.508z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116938862940529352250000001291230486483521456_",
    gradientUnits: "userSpaceOnUse",
    x1: -640.8837,
    y1: 1968.3893,
    x2: -640.8837,
    y2: 2165.2168,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116938862940529352250000001291230486483521456_)"
    },
    d: "M2726.163,2052.634l9.128,93.26 c0,0-52.464,15.802-90.623-11.122l26.824-84.76L2726.163,2052.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132801485701932790200000007959200863159030442_",
    gradientUnits: "userSpaceOnUse",
    x1: 2949.1147,
    y1: 1578.2417,
    x2: 2456.1904,
    y2: 2447.7041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132801485701932790200000007959200863159030442_)"
    },
    d: "M2550.19,2334.199 c0.068,0,0.137-0.005,0.206-0.013c0.903-0.113,1.543-0.935,1.43-1.839c-0.09-0.724-8.967-72.725-4.149-93.468 c0.206-0.886-0.344-1.771-1.231-1.977c-0.88-0.219-1.773,0.344-1.977,1.23c-4.952,21.312,3.716,91.639,4.088,94.623 C2548.66,2333.589,2549.371,2334.199,2550.19,2334.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058555468973504932370000009425564919682294410_",
    gradientUnits: "userSpaceOnUse",
    x1: -270.5924,
    y1: 2011.2472,
    x2: -447.0361,
    y2: 2260.1904,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058555468973504932370000009425564919682294410_)"
    },
    d: "M2341.485,2014.193 c0.077-1.933,1.01-3.731,2.546-4.907c1.536-1.176,3.515-1.609,5.401-1.179l47.094,10.712c1.829,0.416,3.053,2.139,2.844,4.003 l-13.693,122.403c-0.059,0.528-0.326,1.01-0.743,1.34c-0.417,0.329-0.948,0.479-1.475,0.415l-41.107-4.981 c-3.367-0.408-5.857-3.333-5.721-6.722L2341.485,2014.193z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013873638526879993270000015350452477373111448_",
    gradientUnits: "userSpaceOnUse",
    x1: 2348.7573,
    y1: 2076.6992,
    x2: 2393.0784,
    y2: 2076.6992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013873638526879993270000015350452477373111448_)"
    },
    d: "M2354.729,2021.255 c0.061-1.097,0.608-2.109,1.493-2.761c0.885-0.651,2.013-0.875,3.08-0.608l30.985,7.746c1.792,0.448,2.975,2.153,2.768,3.987 l-11.756,104.237c-0.062,0.547-0.347,1.043-0.787,1.372c-0.441,0.329-0.998,0.461-1.539,0.365l-28.573-5.085 c-0.991-0.177-1.694-1.065-1.638-2.07L2354.729,2021.255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156572975349886879590000005669669358905015726_",
    gradientUnits: "userSpaceOnUse",
    x1: -400.9523,
    y1: 2277.2708,
    x2: -413.0303,
    y2: 2294.3115,
    gradientTransform: "matrix(-0.9792 -0.2029 -0.1066 0.5144 2226.5334 763.8746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8D55D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#1C2873"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156572975349886879590000005669669358905015726_)"
    },
    d: "M2372.534,2018.45 c-0.076,0.369,0.431,0.786,1.133,0.932l10.361,2.147c0.703,0.146,1.334-0.035,1.41-0.404l0.074-0.359 c0.077-0.369-0.431-0.786-1.133-0.932l-10.361-2.148c-0.702-0.146-1.334,0.036-1.41,0.405L2372.534,2018.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092414459427778048100000005675559264943281054_",
    gradientUnits: "userSpaceOnUse",
    x1: -266.5965,
    y1: 2037.0824,
    x2: -370.8701,
    y2: 2184.2014,
    gradientTransform: "matrix(-1 0 0 1 2049.0955 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092414459427778048100000005675559264943281054_)"
    },
    d: "M2325.129,2045.293 c7.609-2.804,22.497-28.569,25.349-20.093c2.852,8.477-1.204,20.093,0,23.697c1.204,3.605,9.441,23.632,5.734,32.845 c-2.675,6.648-7.087,27.105-9.337,37.979c-0.747,3.609-3.925,6.199-7.611,6.201c-3.686,0.002-6.867-2.584-7.617-6.193 C2331.346,2118.283,2317.521,2048.096,2325.129,2045.293z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006707448387045769510000002968763505323757991_",
    gradientUnits: "userSpaceOnUse",
    x1: 983.8993,
    y1: -5904.498,
    x2: 1023.2647,
    y2: -6162.9404,
    gradientTransform: "matrix(-0.9808 0.1949 0.1949 0.9808 1793.7781 -659.8097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006707448387045769510000002968763505323757991_)"
    },
    d: "M2627.881,1962.946 c0,0-14.012,64.341-9.568,95.767c4.445,31.427,1.755,52.926,38.938,52.044c37.183-0.882,63.901-24.801,74.151-59.021 c0,0,16.219-52.814,6.572-71.207C2728.327,1962.136,2627.881,1962.946,2627.881,1962.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183966855575990953240000015032117872664014985_",
    gradientUnits: "userSpaceOnUse",
    x1: -407.1904,
    y1: 2697.2065,
    x2: -267.2494,
    y2: 2877.3801,
    gradientTransform: "matrix(-0.9808 0.1949 0.1949 0.9808 1793.7781 -659.8097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183966855575990953240000015032117872664014985_)"
    },
    d: "M2714.698,2031.915l-2.225-0.496 c-2.833-0.63-4.563-3.509-3.757-6.297c3.122-10.799,8.543-35.201-5.26-37.899c-17.789-3.478-85.584-3.818-104.235-24.145 c-17.925-19.535-11.654-50.595,4.716-62.328c1.095-0.785,2.601-0.634,3.451,0.412l2.063,2.539 c1.412,1.738,4.222,0.874,4.413-1.357l0,0c0.184-2.142,2.8-3.071,4.273-1.504c5.695,6.058,19.589,14.953,51.931,14.513 c45.963-0.627,78.842,11.491,85.659,41.984c0.433,1.937,2.719,2.608,4.18,1.265c2.877-2.646,7.93-4.623,16.102-0.127 c14.21,7.819,14.505,35.368-7.847,62.519c-1.062,1.29-0.658,3.267,0.893,3.888c5.465,2.189,14.169,8.251-2.538,21.957 c-17.281,14.177-31.886,16.197-37.628,16.384c-1.428,0.046-2.585-1.115-2.556-2.544l0.583-28.107 c0.033-1.59-1.414-2.804-2.974-2.494L2714.698,2031.915z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132080897337421068890000000636242952140452239_",
    gradientUnits: "userSpaceOnUse",
    x1: 935.4387,
    y1: -5911.8936,
    x2: 974.8041,
    y2: -6170.3369,
    gradientTransform: "matrix(-0.9808 0.1949 0.1949 0.9808 1793.7781 -659.8097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132080897337421068890000000636242952140452239_)"
    },
    d: "M2714.71,2037.819 c0,0,2.318-39.783,21.386-32.546c19.068,7.236-0.379,44.134-13.733,48.259L2714.71,2037.819z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothSupport);
export default __webpack_public_path__ + "static/media/bluetooth_support.07e681da5f00bd944eda6a9996a273b4.svg";
export { ForwardRef as ReactComponent };